const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#1e74a9',
                hover: '#176697'
            },
            secondary: {
                main: '#fff'
            },
            action: {
                main: '#ff0000'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};
